import React from 'react';
import { Button, Text } from './styles.js';

const BackButton = ({ className, style, onClick }) => /* @__PURE__ */ React.createElement(Button, { className, style, onClick }, /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "11",
    height: "18",
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("path", { d: "M10 1L2 9L10 17", stroke: "currentColor", strokeWidth: "2" })
), /* @__PURE__ */ React.createElement(Text, null, "Back"));

export { BackButton };
//# sourceMappingURL=index.js.map
